import {
  Box,
  Checkbox,
  Chip,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from '@mui/material'

type Props<T extends string | number> = {
  title: string
  options: { value: T; label: string }[]
  errorMessage?: string
  value?: T
  required?: boolean
  handleChange: (value: T) => void
}

export const DAISelect: React.FC<Props<string>> = props => {
  const { title, options, value, handleChange, errorMessage, required } = props
  return (
    <FormControl fullWidth>
      <InputLabel required={required}>{title}</InputLabel>
      <Select
        required={required}
        value={value}
        disabled={!options.length}
        label={title}
        name={title}
        fullWidth
        onChange={e => handleChange(e.target.value)}
        aria-errormessage="error"
        error={!!errorMessage}
      >
        {options.map(o => (
          <MenuItem key={o.value} value={o.value}>
            {o.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

type MultiSelectProps<T extends string | number> = {
  title: string
  options: { value: T; label: string }[]
  selected: T[]
  handleClick: (value: T) => void
}

export const DAIMultiSelect: React.FC<MultiSelectProps<string>> = props => {
  const { title, options, selected, handleClick } = props
  const id = `multi-select-${title}`
  const labelId = `multi-select-label-${title}`

  return (
    <FormControl fullWidth>
      <InputLabel id={labelId}>{title}</InputLabel>
      <Select
        labelId={labelId}
        id={id}
        value={options.filter(o => selected.includes(o.value))}
        label={title}
        fullWidth
        multiple
        disabled={!options.length}
        renderValue={selected => (
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.5 }}>
            {selected.map(o => (
              <Chip
                key={o.value}
                label={o.label}
                // onDelete={e => {
                //   // TODO: why does this not work?
                //   e.stopPropagation()
                //   handleClick(o.value)
                // }}
              />
            ))}
          </Box>
        )}
      >
        {options.map(o => (
          <MenuItem key={o.value} onClick={() => handleClick(o.value)}>
            <Checkbox checked={selected.includes(o.value)} />
            <Typography>{o.label}</Typography>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}
